module.exports = __webpack_public_path__ + "img/muro_y_acabado.7223cea4.png";